import API from './API';
var HistoryService = {
    getHistory: function (config) {
        return API.get('/history', config);
    }
};
export default HistoryService;
